import { getUserIp } from './ipService'

export { getUserIp }
